import { Download, GridCell, Trash } from '@uhg-uicl/ui-core/dist';
import { InquiriesInitialStateType, InquiryHeader, InquirySearchParams } from './types';

export const INQUIRY_VALIDATION_ERROR_MSG = `Invalid search text, Allowed special characters: - _ .`;
export const INQUIRY_SEARCH_INPUT_PLACEHOLDER = 'Search by Inquiry ID, Claim ID';
export const INQUIRY_SEARCH_GRID_TITLE = 'Search Results';
export const INQUIRY_EMPTY_GRID_RECORD_MESSAGE = 'No records to display at this time.';

export enum ActionTypesInquiry {
  SET_INQUIRY_SEARCH_ID = 'SET_INQUIRY_SEARCH_ID',
  SET_INQUIRY_GRID_COLUMN_CONFIG = 'SET_INQUIRY_GRID_COLUMN_CONFIG',
  SET_INQUIRY_SEARCH_GRID = 'SET_INQUIRY_SEARCH_GRID',
  TOGGLE_SHOW_INQUIRY_SEARCH_GRID = 'TOGGLE_SHOW_INQUIRY_SEARCH_GRID',
  TOGGLE_INQUIRY_LOADING = 'TOGGLE_INQUIRY_LOADING',
  CLEAR_INQUIRIES_SEARCH_PANE_REDUX_DATA = 'CLEAR_INQUIRIES_SEARCH_PANE_REDUX_DATA',
  CLEAR_INQUIRIES_DETAIL_PANE_REDUX_DATA = 'CLEAR_INQUIRIES_DETAIL_PANE_REDUX_DATA',
  TOGGLE_INQUIRY_HEADER_LOADING = 'TOGGLE_INQUIRY_HEADER_LOADING',
  TOGGLE_INQUIRY_MESSAGES_LOADING = 'TOGGLE_INQUIRY_MESSAGES_LOADING',
  SET_INQUIRY_HEADER = 'SET_INQUIRY_HEADER',
  SET_INQUIRY_MESSAGES = 'SET_INQUIRY_MESSAGES',
  SET_INQUIRY_SEARCH_PARAMS = 'SET_INQUIRY_SEARCH_PARAMS',
  TOGGLE_INQUIRY_ADVANCED_SEARCH_LOOPKUP_LOADING = 'TOGGLE_INQUIRY_ADVANCED_SEARCH_LOOPKUP_LOADING',
  SET_INQUIRY_ADVANCED_SEARCH_LOOPKUP_DATA = 'SET_INQUIRY_ADVANCED_SEARCH_LOOPKUP_DATA',
  TOGGLE_INQUIRY_ATTACHMENTS_LOADING = 'TOGGLE_INQUIRY_ATTACHMENTS_LOADING',
  SET_INQUIRY_ATTACHMENT_INFO_DATA = 'SET_INQUIRY_ATTACHMENT_INFO_DATA',
  SET_INQUIRY_ACTIVITY_INFO_DATA = 'SET_INQUIRY_ACTIVITY_INFO_DATA',
  TOGGLE_INQUIRY_ACTIVITY_INFO_LOADING = 'TOGGLE_INQUIRY_ACTIVITY_INFO_LOADING',
  TOGGLE_DETAIL_PANE_LOADING = 'TOGGLE_DETAIL_PANE_LOADING',
  TOGGLE_ADD_RESPONSE_LOADING = 'TOGGLE_ADD_RESPONSE_LOADING',
  TOGGLE_CLOSE_INQUIRY_LOADING = 'TOGGLE_CLOSE_INQUIRY_LOADING',
  TOGGLE_INQUIRY_CATEGORY_LOADING = 'TOGGLE_INQUIRY_CATEGORY_LOADING',
  SET_INQUIRY_CATEGORY_DATA = 'SET_INQUIRY_CATEGORY_DATA',
}

export const InquiriesInititalState: InquiriesInitialStateType = {
  inquirySearchId: '',
  inquiryGridData: [],
  inquiryHeaderDetails: {} as InquiryHeader,
  showInquirySearchGrid: false,
  isInquiryLoading: false,
  isInquiryHeaderLoading: false,
  isInquiryLookupLoading: false,
  inquirySearchParams: {} as InquirySearchParams,
  inquiryAdvancedSearchLookupData: null,
  inquiryMessagesData: [],
  isInquiryMessagesLoading: false,
  isInquiryAttachmentInfoLaoding: false,
  inquiryAttachmentInfoData: [],
  isInquiryActivityInfoLoading: false,
  inquiryActivityInfoData: [],
  isDetailPaneLoading: false,
  isAddResponseLoading: false,
  isCloseInquiryLoading: false,
  isInquiryCategoryLoading: false,
  inquiryCatergory: [],
  inquiryGridColumnConfig: [],
};

export const INQUIRY_SEARCH_RESULT_GRID_COLUMNS = new Set([
  {
    dataName: 'inquiryId',
    text: 'Inquiry Id',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
  },
  {
    dataName: 'clientName',
    text: 'Client',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 200,
  },
  {
    dataName: 'recordType',
    text: 'Reference Type',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
  },
  {
    dataName: 'recordID',
    text: 'Reference ID',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
    cellType: 'custom',
  },
  {
    dataName: 'statusChip',
    text: 'Inquiry Status',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
    isHeaderTruncated: true,
    headerWidth: 85,
  },
  {
    dataName: 'dateCreated',
    text: 'Create Date',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 120,
  },
  {
    dataName: 'dateCompleted',
    text: 'Complete Date',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 120,
  },
  {
    dataName: 'messageType',
    text: 'Request Type',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 85,
  },
  {
    dataName: 'serviceType',
    text: 'Service Type',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 85,
  },
  {
    dataName: 'message',
    text: 'Details',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 200,
  },
  {
    dataName: 'userAccount',
    text: 'Created By',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 150,
  },
  {
    dataName: 'assignToUser',
    text: 'Assigned To',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
  },
]);

export const INQUIRY_SEARCH_DEFAULT_COLUMNS = new Set([
  'inquiryId',
  'statusChip',
  'serviceType',
  'messageType',
  'recordType',
  'recordID',
  'userAccount',
  'message',
  'dateCreated',
  'assignToUser',
  'dateCompleted',
  'clientName',
]);

export const INQUIRY_ADVANCED_SEARCH_DEFAULT_COLUMNS = new Set(['inquiryId', 'statusChip']);

export const INQUIRY_ACTIONS_DROPDOWN_MENUS_DEFAULT = [
  {
    id: 1,
    label: 'Attach a Document',
  },
];

export const INQUIRY_BULK_ACTIONS_DROPDOWN_MENUS_DEFAULT = [
  {
    id: 1,
    label: 'Assigned To',
  },
];

export const INQUIRY_ATTACHMENTS_GRID_COLUMNS = new Set([
  {
    dataName: 'source',
    text: 'Source',
  },
  {
    dataName: 'fileName',
    text: 'File Name',
    cellType: 'custom',
  },
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    cellType: 'custom',
  },
  {
    dataName: 'modifiedDate',
    text: 'Date/Time',
  },
  {
    dataName: 'trashIcon',
    text: <GridCell cellType="icon" data={{ icon: Trash }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
    isHeaderTruncated: true,
    headerWidth: 50,
  },
]);

export const INQUIRY_ACTIVITY_GRID_COLUMNS = new Set([
  {
    dataName: 'userName',
    text: 'User',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 220,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'dateTime',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
]);
